import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
    message
} from "antd";
import { useEffect, useState } from "react";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import Upload from '../../../commons/Upload';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";

const Register = () => {
    const [fileList, setFileList] = useState();
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = useState();
    let { id } = useParams();
    useEffect(() => {
        if (!localStorage.getItem('id')) {
            nofication('warning', 'Cảnh báo', 'Vui lòng đăng xuất và đăng nhập lại để update bản mới');
            return;
        }
        authApis
            .getDetailUser(id)
            .then((data) => {
                if (data.status_code === 200) {
                    form.setFieldsValue(data.user)
                    setImageUrl(data.user?.avatar ? ROOT_URL + data.user.avatar : '')
                    // setImageUrl(data.brand?.image ? ROOT_URL + data.brand.image : '')
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    },[])

    const onFinish = async () => {
        const values = form.getFieldValue();
        if (!values.first_name) {
            message.error("Xin vui lòng nhập tên");
            return;
        }
        if (!values.last_name) {
            message.error("Xin vui lòng nhập tên");
            return;
        }
        if (!values.email) {
            message.error("Xin vui lòng nhập email");
            return;
        }
        if (!values.password) {
            message.error("Xin vui lòng nhập mật khẩu");
            return;
        }
        // console.log(values.password_confirmed)
        if (values.password !== values.password_confirmed) {
            message.error("Mật khẩu không khớp với nhau vui lòng nhập lại");
            return;
        }
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }
        id && formData.append('id', localStorage.getItem('id'));
        formData.append('logo', fileList);
        formData.append('imageUrl', imageUrl)
        await authApis
            .updateUser(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                    localStorage.setItem('username', data.username);
                    localStorage.setItem('id', data.id);
                    localStorage.setItem('avatar', data.avatar);
                 } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Profile"
            link="/profile/"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true} style={{ minHeight: 873 }}>
                <Row gutter={16}>
                    <Col span={24} style={{ paddingRight: "19px" }}>
                        <div className="box-class">
                            <Form.Item label="Avatar" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item>
                            <Form.Item label="First Name" colon={true} name={'first_name'}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Last name" colon={true} name={'last_name'}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Email" colon={true} name={'email'}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="New password" colon={true} name={'password'}>
                                <Input type={'password'} />
                            </Form.Item>
                            <Form.Item label="Password comfirm" colon={true} name={'password_confirmed'}>
                                <Input type={'password'} />
                            </Form.Item>
                            {/* <Form.Item label="Image" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item> */}
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
